import { useState, useMemo } from 'react';
import { threatActors } from '@/mock/threatActors';
import { ViewMode, SeverityFilter } from '@/components/features/threatProfile/ThreatProfileControls';

export const useThreatProfile = () => {
    const [selectedActor, setSelectedActor] = useState<string | null>(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [severityFilter, setSeverityFilter] = useState<SeverityFilter>('all');
    const [viewMode, setViewMode] = useState<ViewMode>('grid');

    const filteredActors = useMemo(() => {
        return threatActors.filter(actor => {
            const matchesSearch = actor.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                actor.aliases.some(alias => alias.toLowerCase().includes(searchQuery.toLowerCase())) ||
                actor.id.toLowerCase().includes(searchQuery.toLowerCase());
            const matchesSeverity = severityFilter === 'all' || actor.severity === severityFilter;
            return matchesSearch && matchesSeverity;
        });
    }, [searchQuery, severityFilter]);

    const selectedActorData = useMemo(() => {
        return threatActors.find(actor => actor.id === selectedActor) || null;
    }, [selectedActor]);

    const handleActorSelect = (actorId: string) => {
        setSelectedActor(actorId);
    };

    return {
        selectedActor,
        searchQuery,
        severityFilter,
        viewMode,
        filteredActors,
        selectedActorData,
        totalActors: threatActors.length,
        setSelectedActor: handleActorSelect,
        setSearchQuery,
        setSeverityFilter,
        setViewMode,
    };
};